/* eslint-disable no-template-curly-in-string */
export default {
  header: {
    cart: 'View Cart',
    contactUs: 'Contact Us',
    home: 'Home',
    logIn: 'Log In',
    logoAlt: '$t(header.home)',
    menu: 'View Menu',
    myAccount: 'My Account',
    skipLink: 'Skip to main content',
  },
  nav: {
    firstTimeLogin: 'First time logging in?',
    forgotLogin: 'Forgot your login info?',
    greeting: 'Hi, {{name}}!',
    hi: 'Hi!',
    logOut: 'Log Out',
    setUpYourAccount: 'Set up your online account',
    sponsorId: 'Sponsor ID',
  },
  mergeFallbacks: {
    childName: 'this child',
    countryName: 'this country',
    rate: '${{rate}}',
  },
};
